import { Box, Button, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import AboutMe from './AboutMe';
// import ParticleBackground from 'react-particle-backgrounds'
import { AnimationOnScroll } from 'react-animation-on-scroll';


export default function IntroductionComp() {
    // const settings = {
    //     canvas: {
    //         canvasFillSpace: true,
    //         width: 100,
    //         height: 100,
    //         useBouncyWalls: false
    //     },
    //     particle: {
    //         particleCount: 50,
    //         color: 'black',
    //         minSize: 1,
    //         maxSize: 5
    //     },
    //     velocity: {
    //         directionAngle: 180,
    //         directionAngleVariance: 0,
    //         minSpeed: 1,
    //         maxSpeed: 3
    //     },
    //     opacity: {
    //         minOpacity: 1,
    //         maxOpacity: 1,
    //         // opacityTransitionTime: 3000
    //     }
    // }
    const [openModal, setOpenModal] = useState(false);
    return (
        <Box className="no-overflow" bgcolor="#BF8D39" maxHeight="75vh" minHeight="25vh" sx={{ width: '100%', display: { sx: "block", md: "flex", lg: "flex" }, flexDirection: "column", justifyContent: "center", alignItems: "center", p: { xs: "1rem", md: "5rem", lg: "5rem" }, textAlign: "center", pt: "0px" }}>
            {/* <ParticleBackground settings={settings} /> */}
            <Grid container className="no-overflow" id="about" spacing={2} direction="column" justifyContent="center" alignItems="center" maxHeight="75vh" minHeight="25vh" color="white" sx={{ p: { xs: "1rem", md: "5rem", lg: "5rem" }, display: { sx: "block", md: "flex", lg: "flex" } }} >
                <Grid item className="no-overflow" sx={{ mr: "auto", ml: "auto" }}>
                    <AnimationOnScroll animateIn="animate__lightSpeedInLeft" animateOnce="true">
                        <Typography className="no-overflow" sx={{
                            display: { xs: 'block', md: 'flex', lg: 'flex' },
                            fontFamily: 'Molin',
                            fontSize: { sx: "0.75rem", md: "1.25rem", lg: "1.25rem" },
                            // fontWeight: 700,
                            color: 'inherit',
                            textDecoration: 'none',
                            textAlign: { xs: "center", md: "left", lg: "left" },
                            mb: "1.5rem"
                        }} >Hey There!</Typography>
                    </AnimationOnScroll>
                    <AnimationOnScroll animateIn="animate__slideInLeft" animateOnce="true">
                        <Typography className="no-overflow" sx={{
                            display: { xs: 'block', md: 'flex', lg: 'flex' },
                            fontFamily: 'Molin',
                            fontSize: { xs: "0.75rem", md: "1rem", lg: "1rem" },
                            // fontWeight: 700,
                            color: 'inherit',
                            // lineHeight:{xs:"1.25rem"},
                            textDecoration: 'none',
                            textAlign: { xs: "center", md: "left", lg: "left" },
                            mb: "0.5rem"
                        }}> I am an Aspiring ML Engineer and Game Developer based in Mumbai, India.</Typography>
                    </AnimationOnScroll>
                    <AnimationOnScroll animateIn="animate__slideInRight" animateOnce="true">
                        <Typography className="no-overflow" sx={{
                            display: { xs: 'block', md: 'flex', lg: 'flex' },
                            fontFamily: 'Molin',
                            fontSize: { xs: "0.75rem", md: "1rem", lg: "1rem" },
                            // fontWeight: 700,
                            color: 'inherit',
                            lineHeight: { xs: "1.25rem", md: "2rem", lg: "2rem" },
                            textDecoration: 'none',
                            textAlign: { xs: "center", md: "left", lg: "left" },
                            mb: "0.5rem"
                        }}> I am learning Web Development through MERN Stack too!</Typography>
                    </AnimationOnScroll>
                    <Grid className="no-overflow" item sx={{ display: "block", alignItems: "center", textAlign: { xs: "center", md: "left", lg: "left" }, width: "100%" }}>
                        <AnimationOnScroll animateIn="animate__slideInUp" animateOnce="true">
                            <Button variant="outlined" onClick={() => { setOpenModal(true) }} sx={{
                                fontFamily: "Title", letterSpacing: '.2rem', alignItems: { xs: "center", md: "flex-start", lg: "flex-start" }, fontSize: { xs: 10, md: 10, lg: 15 },
                                textAlign: { sx: "center", md: "left", lg: "left" }, alignSelf: { xs: "center", md: "flex-start", lg: "flex-start" }, color: "white", padding: "0.5rem", width: { xs: "10rem", md: "12rem", lg: "15rem" }, mt: "2rem", borderColor: "#1D1F2A", borderRadius: 2,
                                ":hover": { backgroundColor: "#FDDF9E", color: "#1D1F2A", }
                            }}>More About Me</Button>
                        </AnimationOnScroll>
                    </Grid>
                </Grid>
            </Grid >
            <AboutMe open={openModal} setOpen={() => setOpenModal(false)} />
        </Box >
    );
}